import styled from 'styled-components';
import { CircleLoader } from 'react-spinners';

const CenteredDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const MarginP = styled.p`
  margin-top: 16px;
`;

type Props = { show?: boolean; message: string };
const LoadingText = (props: Props) => {
  const { show, message } = props;
  if (!show || show === undefined) return null;
  return (
    <CenteredDiv>
      <CircleLoader color={'#0072BB'} />
      <MarginP>{message}</MarginP>
    </CenteredDiv>
  );
};

export default LoadingText;
